export const chartSync = {
  subscribers: [],
  subscribe(callback) {
    this.subscribers.push(callback);
    return () => {
      this.subscribers = this.subscribers.filter(cb => cb !== callback);
    };
  },
  publish(hoverIndex) {
    this.subscribers.forEach(cb => cb(hoverIndex));
  }
};
